import { Field, Input, InputNumber, Spin } from '@/components/commons';
import { Form } from 'antd';
import { useFormContext } from 'react-hook-form';

interface IProps {
  isLoading: boolean;
}

export const CategoryForm: React.FC<IProps> = ({ isLoading }) => {
  const { watch } = useFormContext();
  const isDisabled = watch('isDisabled');

  return (
    <Form layout='vertical'>
      <Spin spinning={isLoading}>
        <Field label='カテゴリー名' name='name' required>
          <Input placeholder='カテゴリー名' maxLength={40} disabled={isDisabled} />
        </Field>
        <Field label='並び順指定' name='sortOrder' required>
          <InputNumber
            placeholder='並び順指定'
            min={0}
            disabled={isDisabled}
            className='w-[120px] bg-white'
            style={{ backgroundColor: '#fff' }}
          />
        </Field>
      </Spin>
    </Form>
  );
};